import { Drawer, type DrawerProps } from '@beeline.com/bp-design-system';

export { Drawer, DrawerProps };
export default Drawer;
